import { useEffect, useRef } from 'react';
import { useQuery } from 'react-query';
import { BeatLoader } from 'react-spinners';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { fetchCollectionResourcesById } from '../../lib/api';
import ResourceCard from '../ResourceCard';

export interface SpotlightCarouselProps {
  collectionId: number;
}

export const SpotlightCarousel = ({ collectionId }: SpotlightCarouselProps) => {
  const swiperRef = useRef<HTMLDivElement>(null);
  const swiperNextRef = useRef<HTMLDivElement>(null);
  const swiperPrevRef = useRef<HTMLDivElement>(null);

  const { data: collectionData, isLoading } = useQuery({
    queryKey: ['collection', collectionId],
    queryFn: () =>
      collectionId ? fetchCollectionResourcesById(collectionId, 1) : undefined,
    enabled: !!collectionId,
  });

  useEffect(() => {
    if (collectionData && swiperRef.current) {
      const swiper = new Swiper(swiperRef.current!, {
        slidesPerView: 1.4,
        spaceBetween: 30,
        modules: [Navigation],
        navigation: {
          nextEl: swiperNextRef.current,
          prevEl: swiperPrevRef.current,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });

      return () => {
        swiper.destroy();
      };
    }
  }, [collectionData]);

  if (isLoading) {
    return <BeatLoader color="#000000" />;
  }

  return (
    <div className="spotlight-carousel swiper-container">
      <div className="swiper" ref={swiperRef}>
        <div className="swiper-wrapper">
          {collectionData?.data.map((resource) => (
            <div className="swiper-slide" key={resource.ref}>
              <ResourceCard resource={resource} />
            </div>
          ))}
        </div>
      </div>
      <div className="swiper-button-prev" ref={swiperPrevRef}></div>
      <div className="swiper-button-next" ref={swiperNextRef}></div>
    </div>
  );
};
